module.exports = __webpack_public_path__ + "media/images/icon-address-0224ac629b77882c6940bb6482ab9a02.svg";